<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getUserTypeList_data.yutName"
          placeholder="请输入用户类型名"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserTypeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button
          v-if="addUserType"
          @click=" $form('addUserType') "
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加用户类型
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserTypeList'
      api='getUserTypeList'
      updateapi='updateUserType'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addUserType:    [ "新增用户类型信息", "el-icon-circle-plus" ],
        updateUserType: [ "修改用户类型信息", "el-icon-edit-outline"],
        $succeed$: getUserTypeList
      }'
      @close='$form("addUserType","reset")' >
  	  <template v-slot:yutId="{Myformdata}" >
  		  <el-select v-model='Myformdata.yutId' >
  			   <el-option >444444444</el-option>
  		  </el-select>
  	  </template>
      <hide slot='yutId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      yutId: null,

      tableColums_getUserTypeList: {
        $selection: false,

        yutName: '用户类型名称',

        $operation: [
          '操作', 200,
          this.updateUserType &&`@text: 编辑#success
           @v-if: $row.yutId != 1 && $row.yutId != 2
           @click: $form("updateUserType",$row)
          `,
          this.deleteUserType && `@text: 删除#danger
           @v-if: $row.yutId != 1 && $row.yutId != 2
           @click: _confirm('确定要删除该用户类型吗?')
                   .trigger('deleteUserType',{yutId:$row.yutId})
                   .trigger('getUserTypeList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getUserTypeList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/User/UserType.vue